import { inject } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { Layer } from 'bernie-view';

import { LoyaltyEducation } from 'models/common/loyalty-education';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';

import { LoyaltyEducationDialogContent } from './loyalty-education-dialog-content';

export interface LoyaltyEducationDialogProps extends RouteComponentProps {
  loyaltyEducation?: LoyaltyEducation;
  analytics?: AnalyticsStore;
}

@inject('analytics')
export class LoyaltyEducationDialogComponent extends React.Component<LoyaltyEducationDialogProps> {
  private handleDismiss = () => {
    this.props.history.goBack();
  };

  public render(): JSX.Element {
    const toolbarAnalytics = this.props.analytics.setupTracker('RewardsEducationDialog.Close', 'Rewards Education Dialog');
    const { loyaltyEducation } = this.props;

    return (
      <Layer id="join-rewards" onDismiss={this.handleDismiss}>
        <UitkFullscreenDialog dialogShow={true}>
          <UitkToolbar type={ToolbarType.CLOSE} action={this.handleDismiss} analytics={toolbarAnalytics} />
          <UitkDialogContent>
            <LoyaltyEducationDialogContent loyaltyEducation={loyaltyEducation} />
          </UitkDialogContent>
        </UitkFullscreenDialog>
      </Layer>
    );
  }
}

export const LoyaltyEducationDialog = withRouter(LoyaltyEducationDialogComponent);
